export default {
  LOGIN: '/login',
  REGISTER: 'https://lanetalk.com/bowlers/',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset/:token',
  HOME: '/',
  LIVESCORING: '/livescoring/:uuid',
  SWEDISH_LEAGUE_LIVE: '/livescoring/:uuid/swedish-league/:league',
  SWEDISH_LEAGUE: 'https://lanetalk.com/bildscoring_lista/',
  TERMS:
    'https://s3.eu-west-2.amazonaws.com/agreements.lanetalk.com/app-tos/app-tos-v3.html',
  PRIVACY:
    'https://s3.eu-west-2.amazonaws.com/agreements.lanetalk.com/privacy-policy/privacy-policy-v2.html',
  REDIRECT_FROM_BETA: '/bowlingcenters/:uuid/livescoring',
};
